import moment from 'moment'
import PropTypes from 'prop-types'

import styles from './Header.module.scss'

const Header = ({
  convertedClientName,
  convertedFormattedAddress,
  convertedPhoneNumber,
  convertedEmail,
  checkIn,
  checkOut
}) => {
  return (
    <div className={styles.container}>
      <>
        <div className={styles.mainColumn}>
          <span className={styles.username}>{convertedClientName}</span>
        </div>
        <div className={styles.column}>
          <div className={styles.row}>
            <span className={styles.faded}>Address</span>
            {convertedFormattedAddress}
          </div>
        </div>
        <div className={styles.column}>
          <div className={styles.row}>
            <span className={styles.faded}>Email</span>
            {convertedEmail}
          </div>
        </div>
        <div className={styles.column}>
          <div className={styles.row}>
            <span className={styles.faded}>Phone</span>
            {convertedPhoneNumber}
          </div>
        </div>
        <div className={styles.column}>
          <div className={styles.row}>
            <span className={styles.faded}>Check-in</span>
            {moment(checkIn).format('MM/DD/YYYY')}
          </div>
        </div>
        <div className={styles.column}>
          <div className={styles.row}>
            <span className={styles.faded}>Check-out</span>
            {moment(checkOut).format('MM/DD/YYYY')}
          </div>
        </div>
      </>
    </div>
  )
}

Header.propTypes = {
  invitedEmail: PropTypes.string,
  invitedFormattedAddress: PropTypes.string,
  invitedPhoneNumber: PropTypes.string,
  invitedSubscriberName: PropTypes.string
}

export default Header
